import { useState } from 'react';
import ListProducts from '../../components/Products/ListProducts';
import CreateProduct from '../../components/Products/CreateProduct';
import EditProduct from '../../components/Products/EditProduct';
import Reports from '../Reports';
import Stocktakings_report_Com from '../../components/reports/OsStocktakingReportCom';


const Stocktakings_report = () => {
    const [mode,setMode] = useState('List');
    const [idSelected,setIdSelected] = useState();

    return (
        <>
            <div className="p-5">
                { mode === 'List' && <Stocktakings_report_Com idSelected = {idSelected} setIdSelected = {setIdSelected} setMode={setMode} /> }
            </div>
        </>
    );
}

export default Stocktakings_report